module.exports = __webpack_public_path__ + "static/media/Hair_3_brown.62170970.svg";